import PropTypes from 'prop-types';
import { Component } from 'react';
import { Text } from 'foundations-components/components/Text';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import ClassicNotificationEmailActionMetadata from 'automation-ui-action-features/actions/classic-notification-email/records/ClassicNotificationEmailActionMetadata';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import { jsx as _jsx } from "react/jsx-runtime";
class ClassicNotificationEmailActionDetail extends Component {
  renderRecipients() {
    const {
      flowObjectTypeId,
      actionMetadata: {
        recipientEmails,
        recipientProperty
      }
    } = this.props;
    if (!(recipientEmails || []).length && !recipientProperty) {
      return /*#__PURE__*/_jsx(MissingLabel, {
        type: "recipient"
      });
    }
    const recipientList = [].concat(recipientEmails.map(email => /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: email
    }, email))).concat(recipientProperty ? [/*#__PURE__*/_jsx(PropertyName, {
      propertyName: recipientProperty,
      objectTypeId: flowObjectTypeId
    }, recipientProperty)] : []);
    return /*#__PURE__*/_jsx(FormattedList, {
      children: recipientList
    });
  }
  render() {
    const {
      actionMetadata: {
        emailContentId
      },
      messageLangPath
    } = this.props;
    const options = {
      emailName: /*#__PURE__*/_jsx(EmailName, {
        id: emailContentId
      }),
      recipients: this.renderRecipients()
    };
    return /*#__PURE__*/_jsx("div", {
      children: messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.classic-notification-email.action-detail.content",
        options: options
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.classic-notification-email.action-preview.content",
        options: options
      })
    });
  }
}
ClassicNotificationEmailActionDetail.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicNotificationEmailActionMetadata).isRequired,
  messageLangPath: PropTypes.string,
  flowObjectTypeId: ObjectTypeIdType.isRequired
};
ClassicNotificationEmailActionDetail.defaultProps = {
  messageLangPath: 'actionDetail'
};
export default ClassicNotificationEmailActionDetail;